import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DynamicInput from "../../../screens/user-basic-details/feilds/dynamic-input";
import { capitalizeFirstLetter } from "../../../utils/index";
import CountryStateDistrict from "../../../utils/Data";

const MerchantDetailsForm = ({
  formik,
  isPasswordOpen,
  setIsPasswordOpen,
  setIsOtpDialogOpen,
  isMobileVerified,
}: {
  formik: any;
  isPasswordOpen: boolean;
  setIsPasswordOpen: (value: boolean) => void;
  setIsOtpDialogOpen: (value: boolean) => void;
  isMobileVerified: boolean;
}) => {
  const [stateOptions, setStateOptions] = useState<Array<{ value: string; label: string }>>([]);
  const [districtOptions, setDistrictOptions] = useState<Array<{ value: string; label: string }>>([]);
  const [currentStateOptions, setCurrentStateOptions] = useState<Array<{ value: string; label: string }>>([]);
  const [currentDistrictOptions, setCurrentDistrictOptions] = useState<Array<{ value: string; label: string }>>([]);

  // Load state options on component mount
  useEffect(() => {
    const states = CountryStateDistrict.getStatesByCountryId(1);
    const options = states.map((state: any) => ({
      value: state.name,
      label: state.name,
    }));
    setStateOptions(options);
    setCurrentStateOptions(options);
  }, []);

  // Update district options when state changes
  useEffect(() => {
    if (formik.values.state) {
      const stateObj = CountryStateDistrict.getAllStates().find(
        (s) => s.name === formik.values.state
      );

      if (stateObj) {
        const districts = CountryStateDistrict.getCitiesByStateId(stateObj.id);
        const options = districts.map((district: any) => ({
          value: district.name,
          label: district.name,
        }));
        setDistrictOptions(options);
      }
    }
  }, [formik.values.state]);

  // Update current district options when current state changes
  useEffect(() => {
    if (formik.values.currentstate) {
      const stateObj = CountryStateDistrict.getAllStates().find(
        (s) => s.name === formik.values.currentstate
      );

      if (stateObj) {
        const districts = CountryStateDistrict.getCitiesByStateId(stateObj.id);
        const options = districts.map((district: any) => ({
          value: district.name,
          label: district.name,
        }));
        setCurrentDistrictOptions(options);
      }
    }
  }, [formik.values.currentstate]);

  const handleStateChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const stateName = e.target.value;
    formik.setFieldValue("state", stateName);
    formik.setFieldValue("district", ""); // Reset district when state changes
  };

  const handleCurrentStateChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const stateName = e.target.value;
    formik.setFieldValue("currentstate", stateName);
    formik.setFieldValue("currentdistrict", "");
  };

  return (
    <Box
      border={1}
      borderColor="rgba(0,0,0,0.2)"
      borderRadius={2.5}
      flex={1}
      p={3}
    >
      <Box display="flex" flexDirection="row" gap={2}>
        <DynamicInput
          formik={formik}
          name="userType"
          label="Your role*"
          value={
            (capitalizeFirstLetter(formik.initialValues.userType) as string) ||
            ""
          }
          type="text"
          placeholder="Enter UserType"
          disabled={true}
        />
        <DynamicInput
          verified={isMobileVerified}
          formik={formik}
          name="mobileNumber"
          label="Mobile Number*"
          type="text"
          placeholder="Enter your mobile Number"
          disabled={true}
        />
      </Box>

      <Box display="flex" flexDirection="row" gap={2}>
        <DynamicInput
          formik={formik}
          name="fullName"
          label="Full Name*"
          type="text"
          placeholder="Enter your full name"
          inputProps={{
            maxLength: 12,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
         <DynamicInput
          formik={formik}
          name="age"
          label="Age*"
          type="text"
          placeholder="Enter your age"
        />
      </Box>

      <Box display="flex" flexDirection="row" gap={2}>
      <DynamicInput
          formik={formik}
          name="gender"
          label="Gender*"
          type="select"
          options={[
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
            { value: "Other", label: "Other" },
          ]}
        />
        <DynamicInput
          formik={formik}
          name="emailId"
          label="Email Address*"
          type="text"
          placeholder="Enter your email"
          disabled={true}
        />
      </Box>

      <Box display="flex" flexDirection="row" gap={2}>
      <DynamicInput
          formik={formik}
          name="address"
          label="Communication Address*"
          type="text"
          placeholder="Enter your address"
          inputProps={{
            maxLength: 12,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
        />
       <DynamicInput
          formik={formik}
          name="state"
          label="State*"
          type="select"
          placeholder="Select your state"
          options={stateOptions}
          onChange={(e) => handleStateChange(e)}
        />
      </Box>

      <Box display="flex" flexDirection="row" gap={2}>
        
        <DynamicInput
          formik={formik}
          name="district"
          label="District*"
          type="select"
          placeholder="Select your district"
          options={districtOptions}
          disabled={!formik.values.state}
        />
        <DynamicInput
          formik={formik}
          name="pincode"
          label="PIN code*"
          type="text"
          placeholder="Enter your pin code"
        />
      </Box>

      <Typography
        sx={{
          color: "#474747",
          fontFamily: "Maven Pro, sans-serif",
          fontSize: "22px",
          fontWeight: 500,
          lineHeight: "36px",
          textAlign: "left",
          textUnderlinePosition: "from-font",
          textDecorationSkipInk: "none",
          marginTop: "20px",
        }}
      >
        Contact Information{" "}
        <Typography
          variant="subtitle1"
          fontFamily={"Inter"}
          fontWeight={"500"}
          fontSize={14}
        >
          (Please provide your WhatsApp number for real-time booking alerts)
        </Typography>
      </Typography>
      <Box display="flex" flexDirection="row" gap={2}>
        <DynamicInput
          formik={formik}
          name="primaryNumber"
          label="Primary WhatsApp Number*"
          type="number"
          placeholder="Enter your primary number (WhatsApp)"
          disabled={!formik.values.state}
          maxLength={10}
        />
        <DynamicInput
          formik={formik}
          name="secondaryNumber"
          label="Alternative WhatsApp Number"
          type="number"
          placeholder="Enter your secondary number (optional)"
          maxLength={10}
        />
      </Box>

      <Typography
        sx={{
          color: "#474747",
          fontFamily: "Maven Pro, sans-serif",
          fontSize: "24px",
          fontWeight: 500,
          lineHeight: "36px",
          textAlign: "left",
          textUnderlinePosition: "from-font",
          textDecorationSkipInk: "none",
          marginTop: "20px",
        }}
      >
        Office is currently in
      </Typography>

      <DynamicInput
        formik={formik}
        name="currentstate"
        label="State*"
        type="select"
        placeholder="Select your state"
        options={currentStateOptions}
        onChange={handleCurrentStateChange}
      />
      <DynamicInput
        formik={formik}
        name="currentdistrict"
        label="District*"
        type="select"
        placeholder="Select your district"
        options={currentDistrictOptions}
        disabled={!formik.values.currentstate}
      />
      <DynamicInput
        formik={formik}
        name="experience"
        label="Years of Experience*"
        type="text"
        placeholder="Enter your year of Experience"
      />
    </Box>
  );
};

export default MerchantDetailsForm;